import ErrorInterstitial from './ErrorInterstitial';
export * from './ErrorInterstitial';
export default ErrorInterstitial;
